import { getRequestedLastPage } from 'Shared/utils/last-page';
import { isOidcAuthorizePath } from 'Shared/utils/oidc-authorize';
import { parseDomain } from 'Shared/utils/parse-domain';
import { SettingsCookie } from 'Shared/utils/settings-cookie';

const threeHoursInSeconds = 60 * 60 * 3;

const lastViewedParameter = getLastViewedParameter();
const isValidParameter = lastViewedParameter && isValidLastPage(lastViewedParameter.href);

const onJoinOrLogin = new RegExp('(/login)|(/join)', 'i').test(window.location.href);
if ((!App.isLoggedIn && !onJoinOrLogin) || isValidParameter) {
   const lastPage = isValidParameter ? lastViewedParameter : new URL(window.location.href);
   lastPage.searchParams.delete('status');
   SettingsCookie.set('last_page', lastPage.href, threeHoursInSeconds);
}

function getLastViewedParameter() {
   const param = getRequestedLastPage();
   if (!param) {
      return null;
   }

   let url;
   try {
      url = decodeURIComponent(param);
   } catch {
      return null;
   }

   try {
      return new URL(url);
   } catch {
      return new URL(url, window.location.origin);
   }
}

function isValidLastPage(url: string) {
   const notCurrentSite = !isCurrentSite(url);
   const notLocalhostInDevelopment = !url.includes('localhost') || App.isProduction;

   if (notCurrentSite && notLocalhostInDevelopment) {
      return false;
   }

   if (url.endsWith('Dev/blank')) {
      return false;
   }

   // An OIDC authorize URL must survive the login round trip so the
   // OAuth flow resumes after sign-in (see Shared/utils/oidc-authorize).
   if (isOidcAuthorizeUrl(url)) {
      return true;
   }

   const invalidPages = [
      'place-order',
      'login',
      '/://0',
      'xml',
      'skin1.less',
      'logout',
      'blank.gif',
      'graph/time',
      'beta',
      '/favicon',
      '/api/',
      '/Guide/embed/',
      '.js',
   ];

   return !invalidPages.some(pageName => url.includes(pageName));
}

function isOidcAuthorizeUrl(url: string) {
   try {
      return isOidcAuthorizePath(new URL(url, window.location.origin).pathname);
   } catch {
      return false;
   }
}

function isCurrentSite(url: string) {
   try {
      const parsedUrl = new URL(url);
      const currentDomain = parseDomain()['domain'];

      // Allow redirects to any other *.ifixit.com domain.
      return parsedUrl.hostname.endsWith(`.${currentDomain}`);
   } catch {
      // relative url
      return true;
   }
}
